import { sanitizeNamespaceName } from '../../../utils/namespace';

import {
  activeNamespaceField,
  sortSeverities,
  toRescanIntervalHours,
  VulnerabilityScanningFormValues,
  VulnerabilityScanningPolicyPayload,
} from './types';

export function buildVulnerabilityScanningPayload(
  formData: VulnerabilityScanningFormValues
): VulnerabilityScanningPolicyPayload {
  const mode = formData.namespaceScopeMode;
  const namespaces = (formData[activeNamespaceField(mode)] || [])
    .map(sanitizeNamespaceName)
    .filter((namespace) => namespace !== '');

  const hours = toRescanIntervalHours(
    formData.rescanIntervalValue,
    formData.rescanIntervalUnit
  );

  return {
    scanners: ['vulnerability'],
    rescanInterval: `${hours}h`,
    maxConcurrentScans: formData.maxConcurrentScans,
    severities: sortSeverities(formData.severities),
    targetNamespace: sanitizeNamespaceName(formData.targetNamespace),
    namespaceScope: { mode, namespaces },
  };
}
